<p-fileUpload
  chooseIcon="pi pi-cloud-upload"
  name="ui-core-file-upload-data[]"
  styleClass="ui-core-file-upload {{ options().styleClass ?? '' }}"
  [chooseLabel]="options().browseLabel"
  [accept]="options().acceptedFileType"
  [maxFileSize]="options().maxFileSize"
  [multiple]="options().multiple"
  [disabled]="options().disabled"
  [showCancelButton]="false"
  [showUploadButton]="false"
  (onSelect)="selectFile.emit($event)"
>
  <ng-template #header />
  <ng-template #content let-files let-chooseCallback="chooseCallback">
    @if (files && files.length > 0) {
      <ng-content select="[customErrorMessage]" />
    }
    <div class="custom-header">
      <p-button
        type="button"
        label="{{ options().browseLabel }}"
        icon="pi pi-cloud-upload"
        (onClick)="chooseCallback()"
      ></p-button>
      <div class="text-center mt-3">
        <p class="mb-0">{{ options().toolbarLabel }}</p>
      </div>
    </div>
    @if (files && files.length > 0) {
      <div>
        @for (file of files; track file; let i = $index) {
          <div class="card mt-2 bg-white">
            <div class="card-body d-flex justify-content-between align-items-center">
              <div class="d-flex gap-2 align-items-center">
                <i class="pi pi-upload fw-bold rr-text-primary"></i>
                <div>
                  <p class="mb-0">{{ file.name }}</p>
                  <div class="d-flex gap-1">
                    <small class="text-muted">{{ file.size | rrUiCoreFileSize }}</small>
                    <div class="dot-separator text-muted"></div>
                    <small class="text-muted">Complete</small>
                  </div>
                </div>
              </div>
              @if (options().showRemoveButton) {
                <p-button
                  icon="pi pi-trash"
                  severity="danger"
                  [text]="true"
                  (onClick)="onRemoveFile(files, i)"
                ></p-button>
              }
            </div>
          </div>
        }
      </div>
    }
    @if (uploadTpl()) {
      <ng-container *ngTemplateOutlet="uploadTpl()!; context: { files: files }" />
    }
  </ng-template>
  <ng-template #file />
</p-fileUpload>
